"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transfer = void 0;
const web3_js_1 = require("@solana/web3.js");
function transfer(from, to, lamports) {
    return (funder) => {
        var _a;
        return Promise.resolve({
            instruction: web3_js_1.SystemProgram.transfer({
                fromPubkey: (_a = from === null || from === void 0 ? void 0 : from.publicKey()) !== null && _a !== void 0 ? _a : funder.publicKey(),
                toPubkey: to,
                lamports,
            }),
            signers: [from !== null && from !== void 0 ? from : funder],
        });
    };
}
exports.transfer = transfer;
//# sourceMappingURL=systemProgram.js.map